export default __webpack_public_path__ + "static/img-asaas--mobile-a520444f4e5f11108d84fc9b2f0c69a8.webp";